// Theme sync: <head> の <meta name="akebono-theme"> を読んで
// <html> の class="theme-<key>" を同期する。
//
// なぜ必要か:
//   Turbo Drive は <body> の中身を replace するが、 <html> element の
//   class や attributes は **再評価しない**。 そのため layout 側で
//   <html class="theme-<key>"> を出力しても、 Turbo 遷移後はそのまま
//   残ってしまう。 ページ毎の theme 切替を有効にするため、
//   turbo:load (= Turbo の navigation 完了タイミング) で JS が同期する。
//
// 初回ロード時は SSR が <html class> を付与しているのでチラつかず、
// 2 回目以降の Turbo 遷移では JS が class を入れ替える。

function applyThemeFromMeta() {
  const meta = document.querySelector('meta[name="akebono-theme"]')
  const key  = meta?.content?.trim() || "indigo"
  const cls  = document.documentElement.classList
  // 既存の theme-* class を全消去
  for (const c of Array.from(cls)) {
    if (c.startsWith("theme-")) cls.remove(c)
  }
  // indigo は default (= class なし)
  if (key && key !== "indigo") cls.add(`theme-${key}`)
}

// Turbo Drive の navigation 完了時
document.addEventListener("turbo:load", applyThemeFromMeta)
// 初回ロード時 (DOMContentLoaded はもう過ぎてる可能性あるので即時実行)
applyThemeFromMeta()
